import { SendingMessage } from "../models/message/MessageTypes";
import { TARGET_ORIGIN_URL } from "./Constants";

export function currencyFormat(num: number): string {
    return `${num.toFixed(2)}`;
}

export function sendLiveEditorMessage(message: SendingMessage) {
    window.parent.postMessage(message, TARGET_ORIGIN_URL);
}